import { Dialog, Transition } from '@headlessui/react'
import { Fragment, ReactNode } from 'react'

type BottomBarDialogProps = {
  open: boolean
  handleClose: () => void
  items: string[]
  renderItem: (key: string) => ReactNode | null
}

export const MobileBottomBarDialog = ({
  open,
  handleClose,
  items,
  renderItem,
}: BottomBarDialogProps) => {
  return (
    <Transition appear show={Boolean(open)} as={Fragment}>
      <Dialog as="div" className="relative" style={{ zIndex: 99 }} onClose={handleClose}>
        {/* overlay */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        {/* panel */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="translate-y-full opacity-0 scale-95"
          enterTo="translate-y-0 opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="translate-y-0 opacity-100 scale-100"
          leaveTo="translate-y-full opacity-0 scale-95"
        >
          {/* ⚠️ No overflow-y-hidden + resize-safe height */}
          <div className="fixed inset-0">
            <div
              className="flex h-[calc(var(--vh)*100)] items-end justify-end space-x-2 text-center"
              style={{ WebkitOverflowScrolling: 'touch' as any, overscrollBehavior: 'contain' }}
            >
              <Dialog.Panel className="w-full bg-background shadow-xl transition-all">
                <div className="container bg-background py-6 w-full">
                  <div className="flex flex-col w-full">
                    <div
                      className="flex flex-wrap w-full justify-start items-center"
                      style={{ WebkitOverflowScrolling: 'touch' as any }}
                    >
                      {items.map((key) => {
                        const rendered = renderItem(key)
                        return (
                          rendered ?? (
                            <p key={key} className="dark:text-white">
                              {key}
                            </p>
                          )
                        )
                      })}
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </div>
          </div>
        </Transition.Child>
      </Dialog>
    </Transition>
  )
}
